<template>
  <div class="landing">
    <div class="top_banner">
      <a href="#" v-on:click="about = !about" class="info_button">i</a>
      <a href="#" v-on:click="stopAudio" class="mute_button">
        <v-icon :name="icon">
        </v-icon>
      </a>
    </div>
    <div class="title" v-show="locale =='fi'">
      101 Kaikkien Puolesta
    </div>
    <div class="title" v-show="locale == 'en'">
      101 For All
    </div>
    <div class="banner" :style="'background-image: url(' + banner + ')'">
      <router-link :to="{name: 'Index'}" class="button topic_button is-link">
        <div v-show="locale == 'fi'">Aloita</div>
        <div v-show="locale == 'en'">Start</div>
      </router-link>
    </div>
    <audio :src="musicSrc" preload="auto" ref="audio" id="player">
       <p>Your browser does not support the <code>audio</code> element.</p>
     </audio>
    <vue-modaltor class="credit_modal" :visible="about"
                  :bgOverlay='"#333"'
                  :bgPanel='"transparent"'>
      <template slot="close-icon">
        <a href="#" v-on:click="about = !about" class="info_button">x</a>
      </template>
      <div class="tabs">
        <ul>
           <li :class="[activeTab === 'about' ? 'is-active' : '']"><a @click="activeTab = 'about'">Esittely</a>
           </li>
           <li :class="[activeTab === 'credits' ? 'is-active' : '']"><a @click="activeTab = 'credits'">Kreditit</a></li>
         </ul>
      </div>
      <div class="about_text container"  v-show="locale == 'fi' && activeTab === 'about'">
        <div class="inner">
          <p>
            Kuvittele Suomi pienoiskokoon valtioksi, jossa asuu sata ihmistä. Heistä 51 olisi naisia, 13 olisi yli 70 vuotiasta, yksi olisi Aasiasta ja yhdellä olisi tohtorin tutkinto. 101 kaikkien puolesta suuntaa katseen tilastojen takana piilossa oleviin ihmisiin – ja tarinoihin heidän mielipiteidensä takana.
            </p>
            <p>
            Vuonna 2015 taiteilijat Tellervo Kalleinen ja Oliver Kochta-Kalleinen vierailivat ympäri Suomea ja haastattelivat ihmisiä heidän henkilökohtaisesta suhteestaan 30:een mielipiteitä jakavaan teemaan. 100 haastateltavaksi valittua henkilöä muodostavat tilastollisen poikkileikkauksen Suomen väestöstä sukupuolensa, ikänsä, maakuntansa, koulutus- ja tulotasonsa, taustamaansa ja äidinkielensä perusteella.
            </p>
            <p>
            Miksi ajattelemme niin kuin ajattelemme? Haastateltavat yrittivät tunnistaa kokemuksia ja vaikutteita, jotka ovat muovanneet heidän mielipiteitään. Heidän 1900 vastaustaan ovat perusta vuorovaikutteiselle installaatiolle, jonka ensiesitys pidettiin Helsingin Taidehallissa 2015.
            </p>
            <p>
            Suomen Kulttuurirahasto tuki näyttelyä, ja kustansi teoksen siirtämisen myös verkkoon 2019. Jopa 92 sadasta osallistujasta antoi luvan haastattelujensa käyttöön myös taideteoksen verkkoversiossa. Kuva on Helsingin Taidehallin installaatiosta.
          </p>
        </div>
      </div>
      <div class="about_text " v-show="locale == 'fi' && activeTab == 'credits'">
        <div class="credits">
          <div class="left">
            <p>Konsepti, haastattelut, kuvaus ja valot<br />
            <a href="http://studiokalleinen.net">Tellervo Kalleinen & Oliver Kochta-Kalleinen</a>
            </p><p>
            Tuottajat<br />
            Essi Ojanperä, Heini Puurunen
            </p>
            <p>
            Teoksen online -version ohjelmointi<br />
            No Culture Icons
            </p>
            <p>
            Alkuperäisen installaation ohjelmointi<br />
            Oliver Kochta-Kalleinen
            </p>
            <p>
            Käännökset<br />
            Laura Hilska, Susanne Ådahl, Mauri Aarniosuo, Eeva Marttinen
            Jussi Suvanto, Tim Page, Anni Kåhre, Liisa Roberts, Rita Jokiranta
            </p>

            <p>
            Editointi ja värimäärittely<br />
            Nina Forsman, Tellervo Kalleinen, Oliver Kochta-Kalleinen
            </p>
            <p>
            Editoinnin assistentit<br />
            Nina Aspinen, Saana Kotila, Sanna Kultanen
            </p>
          </div>
          <div class="right">
            <p>
              Konsultaatioapu<br />
              Kaskpar Brakis, Tina Cavén, Taru Elfving, Irmeli Kokko, Seppo Laaksonen, Laura Lohikoski, Reijo Sund
            </p>
            <p>
              "Under the Influence of You and Me"<br />
              Konsepti ja lyriikat Tellervo Kalleinen & Oliver Kochta-Kalleinen<br />
              Sävellys ja sovitus Tellervo Kalleinen<br />
              Sello Aino Juutilainen<br />
              Kitara Pentti Luomakangas<br />
              Äänitys ja miksaus P-K Keränen
            </p>
            <p>
              Rahoittajat<br />
              Suomen Kulttuurirahasto<br />
              Koneen säätiö<br />
              AVEK, Elena Näsänen<br />
              Oskar Öflundin säätiö<br />
              Taiteen edistämiskeskus<br />
            </p>
            <p>
              LÄMMIN KIITOS OSALLISTUJILLE!
            </p>
          </div>
        </div>
      </div>
    </vue-modaltor>
  </div>
</template>

<script>
import Vue from 'vue'
import VueModalTor from 'vue-modaltor'

Vue.use(VueModalTor)

export default {
  name: 'Landing',

  data () {
    return {
      about: null,
      activeTab: 'about',
      banner: require('../../static/images/landing.jpg'),
      locale: null,
      icon: 'pause',
      musicSrc: 'https://s3.eu-central-1.wasabisys.com/public101/Taidehallimix_2_influence_geinattu.mp3'
    }
  },
  methods: {
    stopAudio () {
      if (this.$refs.audio.paused) {
        this.$refs.audio.play()
        this.icon = 'pause'
      } else {
        this.$refs.audio.pause()
        this.icon = 'play'
      }
    }
  },
  created () {
    if (localStorage.locale) {
      this.locale = localStorage.getItem('locale')
    }
  },
  mounted () {
    this.$refs.audio.play()
    if (this.$refs.audio.paused) {
      console.log('not playing')
      this.icon = 'play'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Landing.vue